import React from 'react';
import { AutocompleteGetTagProps, Box, Chip } from '@mui/material';

export function renderFilterTag<T>(
  values: T[],
  shortcutValues: T[],
  getTagProps: AutocompleteGetTagProps,
  getLabel: (option: T) => string,
  getShortcutLabel: (option: T) => string,
  limitTags?: number,
): JSX.Element {
  const valuesToRender =
    values.length && limitTags ? values.slice(0, limitTags) : values;
  const lengthDiff = values.length - valuesToRender.length;

  return (
    <Box maxWidth="100%">
      {shortcutValues.map((v) => (
        <Chip
          key={getShortcutLabel(v)}
          size="small"
          label={getShortcutLabel(v)}
          style={{ margin: '2px' }}
        />
      ))}

      {valuesToRender.map((v, index) => (
        <Chip
          key={index}
          size="small"
          label={getLabel(v)}
          {...getTagProps({ index })}
        />
      ))}

      {!!lengthDiff && <Box padding="5px">+{lengthDiff} items</Box>}
    </Box>
  );
  // return <Box paddingRight={1}>{values.length} selected</Box>;
}
